<template>
	<div>
		<!-- 	<div style="width:100%; margin: 10px;">
			<el-row :gutter="24">
				<el-form label-position="right" label-width="100px">
						<el-col :span="6">
							<el-form-item label="项目名称">
								<el-input v-model="query" placeholder="请输入查询条件"></el-input>
							</el-form-item>
						</el-col>
				</el-form>
				<el-col :span="6">
					<el-button type="primary" @click="search">查询</el-button>
				</el-col>
			</el-row>
		</div> -->
		<div style="width:600px;float: left; margin: 10px;">
			<!-- 			<el-input v-model="query" placeholder="请输入机会名称或编码" style="width :300px;float: left; margin-right: 5px;"></el-input>
			<el-button type="primary" @click="search">查询</el-button> -->
			<el-button type="primary" @click="handleAdd">新增</el-button>
		</div>

		<el-table v-loading="loading" border :data="tableData" stripe>
			<el-table-column label="id" prop="id" show-overflow-tooltip v-if="false">
			</el-table-column>
			<el-table-column label="标题" prop="title" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="提交人" width="200" prop="addId.userDesc" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="处理状态" width="200" prop="feedFlag" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="处理人" width="200" prop="feedId.userDesc" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
					<el-button size="mini" type="success" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
		 :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
		</el-pagination>
	</div>
</template>

<script>
	import axios from '@/axios'
	export default {
		data() {
			return {
				show: true,
				tableData: [],
				query: '',
				currentPage: 1,
				totalRows: 0,
				pageSizes: [10, 20, 30, 40],
				pageSize: 10,
				loading: true,
			}
		},
		methods: {
			getTableData() {
				var url = 'framework/SysProblem/query.do'
				var param = {
					page: this.currentPage,
					rows: this.pageSize,
				}
				axios.get(url, param).then(response => {
					if (response.data.code == '0') {
						this.tableData = response.data.data.list
						this.totalRows = response.data.data.total
					} else {
						this.$message({
							type: 'error',
							message: '操作失败!' + response.data.msg
						});
					}
					this.loading = false
				});
			},
			// 修改每页行数
			handleSizeChange(val) {
				this.pageSize = val
				this.getTableData()
			},
			// 修改当前页事件
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData()
			},
			// 查询按钮事件
			search() {
				this.getTableData()
			},
			handleAdd() {
				this.queryPrimaryKey()
			},
			queryPrimaryKey() {
				var url = 'framework/Common/queryPrimaryKey.do'
				var param = {}
				axios.get(url, param).then(response => {
					if (response.data.code == '0') {
						this.gotoDetail(response.data.data)
					} else {
						this.$message({
							type: 'error',
							message: '查询失败' + response.data.msg
						});
					}
				});
			},
			gotoDetail(id) {
				this.$store.commit('setProblemId', id)
				this.$router.push({
					path: '/home/problemDetail',
					meta: {
						keepAlive: false
					}
				})
			},

			handleEdit(row) {
				this.gotoDetail(row.id)
			},
			//开始
			handleDelete(row) {
				this.loading = true
				var url = 'framework/SysProblem/remove.do'
				var param = {
					id: row.id
				}
				axios.post(url, param).then(response => {
					if (response.data.code == '0') {
						this.$message({
							type: 'success',
							message: '操作成功!',
						});
						this.getTableData()
					} else {
						this.$message({
							type: 'error',
							message: '操作失败!' + response.data.msg
						});
					}
					this.loading = false
				});
			},

		},
		mounted() {
			this.getTableData()
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/framework/problem/list.vue